<div>
  <h1>Выберете роль</h1>
  <div class="start-buttons-block">
    <button [routerLink]="['/driver']">Водитель</button>
    <button [routerLink]="['/master']">Мастер</button>
    <button [routerLink]="['/director']">Руководитель</button>
  </div>
</div>
